import { BarSeriesType } from '@mui/x-charts/models';
import { UsageByDateBreakdown } from '@vy/types';
import { flatExtract } from '@vy/utils';
import { buildBarChartSeries } from '../../../../../../../../../utils/charts/bar-chart/build-bar-chart-series';
import { PRODUCT_USAGE_CHART_DATA_KEY } from '../product-usage-breakdown-chart-types/product-usage-chart-data-key';

export function getChartSeriesWithLabels(
  chartData: Record<string, number | string>[],
  usageByDateBreakdowns: UsageByDateBreakdown[],
): BarSeriesType[] {
  const series = buildBarChartSeries(chartData, PRODUCT_USAGE_CHART_DATA_KEY);

  return addLabelsToChartSeries(series, usageByDateBreakdowns);
}

function addLabelsToChartSeries(
  series: BarSeriesType[],
  usageByDateBreakdowns: UsageByDateBreakdown[],
): BarSeriesType[] {
  const customerUsages = flatExtract(usageByDateBreakdowns, 'customerUsage');

  return series.map((item) => {
    const itemCustomer = customerUsages.find((customer) => customer.customerId === item.dataKey);

    return {
      ...item,
      id: item.dataKey,
      label: itemCustomer?.customerName,
    };
  });
}
